import React from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';

import { NavigationLinkProps } from './types';
import { ReactComponent as SpinnerSVG } from 'modules/theme/images/icons/spinners/circular-bars.svg';
import { useActiveAnimation, useHandlers } from './hooks';

import styles from './styles.module.scss';

const NavigationLink: React.FunctionComponent<NavigationLinkProps> = ({
  ariaLabel,
  children,
  className,
  color,
  disabled,
  label,
  itemID,
  itemProp,
  itemScope,
  itemType,
  loading,
  onClick,
  route,
  style,
  title,
}) => {
  const { animation, handleActiveAnimation, ref } = useActiveAnimation();
  const { handleClick, handleMouseDown, handleKeyDown } = useHandlers(
    handleActiveAnimation,
    disabled,
    loading,
    onClick,
  );

  const classNames = clsx(
    style && styles.hyperlink,
    color && styles[`${color}`],
    disabled && styles['disabled'],
    loading && styles['loading'],
    style && styles[`${style}`],
    animation && 'active-animation',
    !disabled && !loading && styles.useable,
    'nav-link',
    className,
  );
  return (
    <NavLink
      aria-label={ariaLabel}
      end
      className={classNames}
      itemID={itemID}
      itemProp={itemProp}
      itemScope={itemScope}
      itemType={itemType}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      onMouseDown={handleMouseDown}
      ref={ref}
      tabIndex={disabled || loading ? -1 : 0}
      title={title || ariaLabel}
      to={route}>
      {label && <span>{label}</span>}
      {loading && <SpinnerSVG />}
      {children}
    </NavLink>
  );
};

export default React.memo(NavigationLink);
